import { Apple, Play, Smartphone, Bell, Zap, Shield, Star } from 'lucide-react';
import './MobilePage.css';

const MobilePage = () => {
  const features = [
    { icon: Zap, title: 'Instant Swaps', desc: 'Exchange crypto in seconds' },
    { icon: Bell, title: 'Price Alerts', desc: 'Get notified of price movements' },
    { icon: Shield, title: 'Secure Wallet', desc: 'Your keys, your crypto' },
    { icon: Star, title: 'Portfolio', desc: 'Track all your assets' },
  ];

  const reviews = [
    { name: 'Alex M.', rating: 5, text: 'Best crypto app I\'ve used. Super fast and reliable!' },
    { name: 'Sarah K.', rating: 5, text: 'Love the clean interface. Makes trading so easy.' },
    { name: 'James R.', rating: 5, text: 'The alerts feature saved me so much money.' },
  ];

  return (
    <div className="mobile-page">
      {/* Background Animation */}
      <div className="mobile-bg">
        <div className="phone-outline"></div>
        <div className="floating-icons">
          <span className="float-icon">₿</span>
          <span className="float-icon">Ξ</span>
          <span className="float-icon">S</span>
        </div>
      </div>

      <div className="mobile-container">
        {/* Hero Section */}
        <section className="mobile-hero">
          <div className="hero-content">
            <div className="app-badge">
              <Smartphone size={20} />
              <span>Mobile App</span>
            </div>
            <h1 className="mobile-title">
              Crypto in Your <span className="gradient-text">Pocket</span>
            </h1>
            <p className="mobile-subtitle">
              Trade 1000+ cryptocurrencies on the go. Fast, secure, and always with you.
            </p>
            <div className="store-buttons">
              <button className="store-btn">
                <Apple size={28} />
                <div className="store-text">
                  <span>Download on the</span>
                  <strong>App Store</strong>
                </div>
              </button>
              <button className="store-btn">
                <Play size={28} />
                <div className="store-text">
                  <span>Get it on</span>
                  <strong>Google Play</strong>
                </div>
              </button>
            </div>
          </div>

          {/* Phone Mockup */}
          <div className="phone-mockup">
            <div className="phone-frame">
              <div className="phone-screen">
                <div className="screen-header">
                  <div className="screen-notch"></div>
                </div>
                <div className="screen-content">
                  <div className="mock-balance">
                    <span className="balance-label">Total Balance</span>
                    <span className="balance-amount">$24,592.50</span>
                    <span className="balance-change">+5.24% today</span>
                  </div>
                  <div className="mock-actions">
                    <button className="mock-action">Buy</button>
                    <button className="mock-action">Sell</button>
                    <button className="mock-action">Swap</button>
                  </div>
                  <div className="mock-coins">
                    <div className="mock-coin">
                      <span className="coin-icon">₿</span>
                      <div className="coin-info">
                        <span className="coin-name">Bitcoin</span>
                        <span className="coin-amount">0.45 BTC</span>
                      </div>
                      <span className="coin-value">$19,462</span>
                    </div>
                    <div className="mock-coin">
                      <span className="coin-icon">Ξ</span>
                      <div className="coin-info">
                        <span className="coin-name">Ethereum</span>
                        <span className="coin-amount">2.8 ETH</span>
                      </div>
                      <span className="coin-value">$7,784</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Features */}
        <section className="mobile-features">
          <h2>Why Use Our App?</h2>
          <div className="features-grid">
            {features.map((feature, index) => (
              <div key={index} className="mobile-feature-card" style={{ animationDelay: `${index * 0.1}s` }}>
                <div className="feature-icon-bg">
                  <feature.icon size={28} />
                </div>
                <h3>{feature.title}</h3>
                <p>{feature.desc}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Stats */}
        <section className="app-stats">
          <div className="stat-box">
            <span className="stat-num">4.9</span>
            <div className="stat-stars">
              {[...Array(5)].map((_, i) => <Star key={i} size={16} fill="#f59e0b" color="#f59e0b" />)}
            </div>
            <span className="stat-label">App Store Rating</span>
          </div>
          <div className="stat-box">
            <span className="stat-num">1M+</span>
            <span className="stat-label">Downloads</span>
          </div>
          <div className="stat-box">
            <span className="stat-num">100+</span>
            <span className="stat-label">Countries</span>
          </div>
        </section>

        {/* Reviews */}
        <section className="reviews-section">
          <h2>What Users Say</h2>
          <div className="reviews-grid">
            {reviews.map((review, index) => (
              <div key={index} className="review-card" style={{ animationDelay: `${index * 0.1}s` }}>
                <div className="review-stars">
                  {[...Array(review.rating)].map((_, i) => <Star key={i} size={16} fill="#f59e0b" color="#f59e0b" />)}
                </div>
                <p className="review-text">&ldquo;{review.text}&rdquo;</p>
                <span className="review-name">{review.name}</span>
              </div>
            ))}
          </div>
        </section>

        {/* Download CTA */}
        <section className="download-cta">
          <div className="cta-box">
            <Smartphone size={48} className="cta-icon" />
            <h2>Download Now</h2>
            <p>Available on iOS and Android</p>
            <div className="cta-buttons">
              <button className="cta-store-btn">
                <Apple size={24} />
                App Store
              </button>
              <button className="cta-store-btn">
                <Play size={24} />
                Google Play
              </button>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default MobilePage;
